(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/categories/category-card.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/categories/category-card.js');
'use strict';

const Card = svs.ui.ReactCard.Card;
const ImageMemo = svs.tickets.next.components.ImageMemo;
const PriceLabel = svs.tickets.next.components.nova.PriceLabel;
const PriceLabelCurrency = svs.tickets.next.components.nova.PriceLabelCurrency;
const baseUrl = svs.core.data.baseUrl || '';
const buildHref = function () {
  let anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!anchor) {
    return '';
  }
  if (/^(https?:)?\/\//.test(anchor)) {
    return anchor;
  }
  const cleanAnchor = anchor.startsWith('/') ? anchor : "/".concat(anchor);
  return "".concat(baseUrl.replace(/\/$/, '')).concat(cleanAnchor).replace(/\/{2,}/g, '/');
};

const splitPriceParts = price => {
  if (!price) {
    return null;
  }
  const match = String(price).match(/^(.*?)(\s*(?:kr(?:\s*\/\s*\S+)?))\s*$/i);
  if (!match) {
    return {
      main: String(price).trim(),
      suffix: ''
    };
  }
  return {
    main: match[1].trim(),
    suffix: match[2].trim()
  };
};
const CategoryCard = _ref => {
  let item = _ref.item;
  const image = item.image,
    description = item.description,
    price = item.price,
    badge = item.badge,
    anchor = item.anchor;
  const href = buildHref(anchor);
  const accessibleLabel = [description, price && "Pris ".concat(price), badge].filter(Boolean).join('. ');
  const priceParts = splitPriceParts(price);
  const cardProps = href ? {
    Component: 'a',
    href
  } : {
    Component: 'div'
  };
  return React.createElement(Card, {
    "aria-label": accessibleLabel || undefined,
    className: "tickets-category-card qa-tickets-category-card",
    Component: cardProps.Component,
    href: cardProps.href
  }, image && React.createElement(ImageMemo, {
    fitWrapper: true,
    image: image,
    loadingLazy: true,
    sizes: "(min-width: 1024px) 198.5px, 175px"
  }), priceParts.main && React.createElement(PriceLabel, {
    className: "u-position-absolute tickets-category-card-price-label",
    edge: "trailing",
    size: "sm",
    variant: "primary"
  }, React.createElement(PriceLabelCurrency, {
    currency: priceParts.suffix,
    price: priceParts.main
  })));
};
setGlobal('svs.tickets.next.components.categories.CategoryCard', CategoryCard);

 })(window);